import { getPrototypeByID } from '@/libs/libraryGetters';
import { getDrawerSeparatorPrototypeById } from '@/libs/libGetters';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import { iCaseComponentsResultItemGroup } from '@/Interfaces/caseComponentsLib';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { getFinalCasePrice } from '@/libs/getFinalPrice';

function getCaseItems() {
    const items = [ ...useStoreCaseConfiguration().caseItems ];
    const itemsCountMap: Record<string, any> = {};

    if (useStoreCaseConfiguration().selectedCaseModel && useStoreCaseConfiguration().selectedCaseModel.toLowerCase().includes('hard')) {
        const caseModels = {
            '1000': [ 'body_hard_1000', 'frame_hard_1000', 'frame_hard_1000' ],
            '2000': [ 'body_hard_2000', 'frame_hard_2000', 'frame_hard_2000' ],
        };
        const modelType = useStoreCaseConfiguration().selectedCaseModel.includes('1000') ? '1000' : '2000';
        caseModels[modelType].forEach(itemId => items.unshift({ prototypeId: itemId }));
    }

    items.forEach(obj => {
        const key = obj.prototypeId;
        if (itemsCountMap[key]) {
            itemsCountMap[key]++;
        } else {
            itemsCountMap[key] = 1;
        }
    });

    // Создаем новый массив для хранения результатов
    const result: Array<iCaseComponentsResultItemGroup> = [];

    // Перебираем массив объектов и добавляем только уникальные, добавляя свойство count
    items.forEach(obj => {
        if (!result.some(item => item.prototypeId === obj.prototypeId)) {
            result.push({ ...obj, count: itemsCountMap[obj.prototypeId] });
        }
    });

    return result;
}

export function computeProjectCost(){
    console.warn(computeProjectCost);
    const casesForProject = useStoreProjectStructure().cases;
    return casesForProject
        .map(toolCase => {
            return getFinalCasePrice(toolCase.id) * (useStoreProjectStructure().getCaseById(toolCase.id)?.count ?? 1);
        })
        .reduce((acc, price) => acc + price, 0);
}

export function computeConfigurationCost() {
    let finalCost = 0;

    // Добавление цены шкафа
    const selectedCase = useStoreCaseConfiguration().getSelectedCaseData;
    if (selectedCase) {
        const casePrice = useStoreItemsFromApi().getApiItemByXmlId(selectedCase.xmlId)?.price ?? 0;
        finalCost += +casePrice;
    }

    // Добавление цены комплектующих
    getCaseItems().forEach(itemGroup => {
        const prototype = getPrototypeByID(itemGroup.prototypeId);
        if (!prototype) {
            console.error('Не найден прототип комплектующего для поиска цены');
            return;
        }
        const apiDataForGroup = useStoreItemsFromApi().getApiItemByXmlId(prototype.xmlId);
        if (!apiDataForGroup) {
            console.error('Не найден данные комплектующего из API для поиска цены');
            return;
        }
        const groupPrice = itemGroup.count * +apiDataForGroup.price;
        finalCost += groupPrice;
    });

    // Добавление цены разделителей
    useStoreCaseConfiguration().drawerSeparators
        .forEach(separator => {
            const prototype = getDrawerSeparatorPrototypeById(separator.prototypeId);
            if (!prototype) {
                console.error('Не найден прототип разделителя для поиска цены');
                return;
            }
            const separatorDataFromApi = useStoreItemsFromApi().getApiItemByXmlId(prototype.xmlId);
            if (!separatorDataFromApi) {
                console.error('Не найден данные разделителя из API для поиска цены');
                return;
            }
            const separatorCost = separator.count * +separatorDataFromApi.price;
            finalCost += separatorCost;
        });

    const selectedCaseId = useStoreProjectStructure().selectedCaseId;

    if (!selectedCaseId) {
        console.error('Не удалось записать цену, нет выбранного шкафа');
    } else {
        useStoreProjectStructure().setCaseCostById(selectedCaseId,
            !useStoreCaseConfiguration().getIsDefaultColorSettings ? 0 : finalCost);
    }

    return finalCost;
}
